export default "__VITE_ASSET__Crh37o$B__"